export default __webpack_public_path__ + "static/media/hajA.35ec730f.jpg";